import { DropDownOptions } from "devextreme-react/drop-down-box";
import { Form, GroupItem,  SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownGrid } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { textEditorOptions } from "../../utils/helpers";
import { CreatePolicies, PolicyType } from "./type";

const createAdminPolicies = forwardRef<any, { data: CreatePolicies }>((
    { data }, ref
) => {

    const [policyTypes, setPolicyType] = useState<PolicyType[]>([])
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const [, setId] = useState("");
    const getPolicyTypes = useCallback(async () => {
        const response: ApiResponse<PolicyType[]> = await createRequest({
            method: "GET",
            url: "/api/admin/adminpolicies/get-policy-types",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setPolicyType(response.Result)
        }
    }, [token, lang])

    useEffect(() => {
        getPolicyTypes()
    }, [getPolicyTypes])

    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Title"}
                editorType={"dxTextBox"}
                editorOptions={{
                    inputAttr: {
                        style: " text-transform: capitalize",
                    },
                }}
                label={{ text: localize.getString("title") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Description"}
                editorType={"dxHtmlEditor"}
                editorOptions={textEditorOptions}
                label={{ text: localize.getString("description") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"IsActive"}
                editorType={"dxCheckBox"}
                editorOptions={{
                    inputAttr: {
                        style: " text-transform: capitalize",
                    },
                }}
                label={{ text: localize.getString("isActive") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"PolicyTypeId"}
                editorType="dxLookup"
                label={{ text: localize.getString("policiesType") }}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={policyTypes}
                        columns={["Code", "Name"]}
                        displayExpr="Code"
                        returnSelectedId={async (id: any) => {
                            item.editorOptions.value = id
                            data.PolicyTypeId = id
                            setId(id);
                        }}
                        value={data.PolicyTypeId}
                        dropDownOptions={{ width: 600 }}
                    />
                )}
            >
                <DropDownOptions closeOnOutsideClick showTitle={false} />
          
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default createAdminPolicies